import { Club } from '@domain/club';

import { MenuVenueButton } from '../menu-venue-button';

export const MenuButtonContent = ({ isOpen, clubState }: { isOpen: boolean; clubState: Club }) => (
  <MenuVenueButton showClubSubmenu={isOpen} clubState={clubState} />
);
